<script setup lang="ts">
export interface Props {
  stockLeft: number
  isOos: boolean
}
const props = defineProps<Props>()

const stockColor = computed(() => {
  if (props.isOos) {
    return 'error'
  }
  if (props.stockLeft || props.stockLeft === 0) {
    switch (true) {
      case props.stockLeft === 1:
        return 'warning'
      case props.stockLeft < 5:
        return 'warning'
      default:
        return 'success'
    }
  }
  return 'success'
})
</script>

<template>
  <div class="product--stock-message">
    <span
      class="stock-message__status"
      :class="stockColor"
    />
    <span><slot /></span>
  </div>
</template>

<style>
  @import url("~layers/app/components/Product/StockMessage.css");
</style>
